const VALID_TABLE_PATHNAMES = ['home', '/sharing/shared'];

export const validTablePath = (pathname: string) => {
  if (VALID_TABLE_PATHNAMES.includes(pathname)) {
    return pathname;
  }
  return 'home';
};
